/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';

export class notebookpagetotype extends IceEntity {
  notebook_page_to_type_key: string = "";
  src_type: IceTypes.SourceType = IceTypes.SourceType.srcUndefined;
  sub_type: number = 0;
  notebook_page_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  public gettablename(): string {
    return "NOTEBOOK_PAGE_TO_TYPE";
  }
}
